var _classCallCheck = require("C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var N2N = require('n2n-overlay-wrtc');

var lmerge = require('lodash.merge');

var uniqid = require('uuid/v4');

var PV = require('./partialview');

var debug = require('debug')('cyclon');
/**
 * Implementation of CYCLON: Inexpensive Membership Management for Unstructured P2P Overlays
 * Spyros Voulgaris,1,2 Daniela Gavidia,1 and Maarten van Steen1
 * @article{voulgaris2005cyclon,
    title={Cyclon: Inexpensive membership management for unstructured p2p overlays},
    author={Voulgaris, Spyros and Gavidia, Daniela and Van Steen, Maarten},
    journal={Journal of Network and Systems Management},
    volume={13},
    number={2},
    pages={197--217},
    year={2005},
    publisher={Springer}
  }
 *
 * @type {[type]}
 */


module.exports =
/*#__PURE__*/
function (_N2N) {
  "use strict";

  _inherits(Cyclon, _N2N);

  function Cyclon(options) {
    var _this;

    _classCallCheck(this, Cyclon);

    var DEFAULT_OPTIONS = {
      pid: 'cyclon',
      peer: uniqid(),
      maxPeers: 5,
      timeoutnetwork: 20 * 1000,
      timeoutconnection: 20 * 1000,
      retry: 5,
      delta: 30 * 1000,
      timeout: 30 * 1000
    };
    _this = _possibleConstructorReturn(this, _getPrototypeOf(Cyclon).call(this, lmerge(DEFAULT_OPTIONS, options)));
    _this._partialView = new PV();
    _this._periodic = undefined;

    _this.on('receive', function (id, msg) {
      return _this._receive(id, msg);
    });

    _this.on('open', function (peerId) {
      _this._open(peerId);
    });

    _this.on('close', function (peerId) {
      _this._close(peerId);
    });

    _this.on('fail', function (peerId) {
      _this._onArcDown(peerId);
    });

    return _this;
  }

  _createClass(Cyclon, [{
    key: "join",

    /**
     * Joining a network.
     * @param {callback} sender Function that will be called each time an offer
     * arrives to this peer. It is the responsability of the caller to send
     * these offer (using sender) to the contact inside the network.
     * @returns {Promise} A promise that is resolved when the peer joins the
     * network -- the resolve contains the peerId; rejected after a timeout, or
     * already connected state.
     */
    value: function join(sender) {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        var to = setTimeout(function () {
          reject(new Error('conenction timed out'));
        }, _this2.options.timeoutconnection); // #2 very first call, only done once

        _this2.once('open', function (peerId) {
          _this2.send(peerId, {
            type: 'MJoin'
          }, _this2.options.retry).then(function () {
            clearTimeout(to);

            _this2._start(); // start shuffling process


            resolve(peerId);
          }).catch(function () {
            reject(new Error('failed to send a MJoin message after establishing the connection. Please report.'));
          });
        });

        _this2.connect(sender);
      });
    }
  }, {
    key: "_open",
    value: function _open(peerId) {
      debug('[%s] %s ===> %s', this.PID, this.PEER, peerId);
      if (!this._partialView.has(peerId)) this._partialView.add(peerId);

      if (this._partialView.size > this.options.maxPeers) {
        this.disconnect(peerId);
      }
    }
    /**
     * @private Behavior when a connection is closed.
     * @param {string} peerId The identifier of the removed arc.
     */

  }, {
    key: "_close",
    value: function _close(peerId) {
      debug('[%s] %s =†=> %s', this.PID, this.PEER, peerId);
      if (this._partialView.has(peerId)) this._partialView.delete(peerId);
    }
  }, {
    key: "_onJoin",
    value: function _onJoin(id) {
      var _this3 = this;

      if (this._partialView.size > 0) {
        // #1 all neighbors -> peerId
        debug('[%s] %s ===> join %s ===> %s neighbors', this.PID, id, this.PEER, this._partialView.size);

        this._partialView.forEach(function (ages, neighbor) {
          _this3.connect(id, neighbor);
        });
      } else {
        // #2 Seems like a 2-peer network;  this -> peerId;
        debug('[%s] %s ===> join %s ===> %s', this.PID, id, this.PEER, id);
        this.connect(null, id);
      }

      ;
    }
  }, {
    key: "_onLeave",
    value: function _onLeave(id) {
      debug('%s: just left the game!', id);
    }
  }, {
    key: "_start",
    value: function _start() {
      var _this4 = this;

      debug('[%s] starting periodic shuffling with period=%f', this.PEER, this.options.delta);
      this._periodic = setInterval(function () {
        _this4.exchange();
      }, this.options.delta);
    }
  }, {
    key: "_stop",
    value: function _stop() {
      clearInterval(this._periodic);
    }
    /**
     * @private Called each time this protocol receives a message.
     * @param {string} peerId The identifier of the peer that sent the message.
     * @param {object|MExchange|MJoin} message The message received.
     */

  }, {
    key: "_receive",
    value: function _receive(peerId, message) {
      if (message.type && message.type === 'MExchange') {
        this._onExchange(peerId, message);
      } else if (message.type && message.type === 'MExchangeBack') {
        this.emit('MExchangeBack-' + message.id, peerId, message);
      } else if (message.type && message.type === 'MJoin') {
        this._onJoin(peerId);
      } else if (message.type && message.type === 'MLeave') {
        this._onLeave(peerId);
      } else if (message.type && message.type === 'MBridge') {
        this._onBridge(message.from, message.to);
      } else {
        throw new Error('_receive, message unhandled');
      }
    }
  }, {
    key: "_exchange",
    value: function _exchange() {
      return this.exchange();
    }
  }, {
    key: "exchange",
    value: function exchange() {
      var _this5 = this;

      this.emit('begin-shuffle');
      return new Promise(function (resolve, reject) {
        if (_this5._partialView.size === 0) resolve(); // 1. Increase by one the age of all neighbors.

        _this5._partialView.increment(); // 2. Select neighbor Q with the highest age among all neighbors, and l − 1
        // other random neighbors.
        // const keys = [...this._partialView.keys()]


        var oldest = _this5._partialView.oldest; // keys[Math.floor(Math.random() * keys.length)]

        var sample = _this5._getSample(_this5.options.maxPeers); // 3. Replace Q’s entry with a new entry of age 0 and with P’s address.


        _this5._partialView.removeOldest(oldest);

        _this5._partialView.add(oldest);

        sample.map(function (samp) {
          if (samp.id === oldest) {
            samp.id = _this5.getInviewId();
            samp.age = 0;
          }
        });
        debug('[%s] Starting to exchange with %s with a sample of size: %f', _this5.PEER, oldest, sample.length); // 4. Send the updated subset to peer Q.
        // need to try with another peer if it fails

        var msgid = uniqid();

        _this5.send(oldest, {
          type: 'MExchange',
          id: msgid,
          from: _this5.getInviewId(),
          sample: sample
        }, _this5.options.retry).then(function () {
          // put a timeout on the reply in order to skip the round
          var timeout = setTimeout(function () {
            _this5.removeAllListeners('MExchangeBack-' + msgid);

            resolve(); // skip the round or perhaps reject?
          }, _this5.options.timeoutnetwork); // 5. Receive from Q a subset of no more that i of its own entries

          _this5.once('MExchangeBack-' + msgid, function (id, message) {
            clearTimeout(timeout); // 6. Discard entries pointing at P and entries already contained in P’s
            // cache.
            // at least put the id of the peer we just exchange samples into the list of arcs to remove

            var tokeep = message.sample.filter(function (samp) {
              if (_this5._partialView.has(samp.id) || samp.id === oldest || samp.id === id) {
                return false;
              } else {
                return true;
              }
            }); // 7. Update P’s cache to include all remaining entries, by firstly using empty
            // cache slots (if any), and secondly replacing entries among the ones sent to Q.

            for (var i = 0; i < tokeep.length; i++) {
              var keep = tokeep[i];

              if (_this5._partialView.size >= _this5.options.maxPeers) {
                var rn = Math.floor(Math.random() * sample.length);
                var idrn = sample[rn].id;
                sample.splice(rn, 1);
                debug('[%s] replacing entry %s by %s', _this5.PEER, idrn, keep.id);

                _this5.disconnect(idrn);

                _this5._partialView.removeAll(idrn);
              }

              _this5.send(id, {
                type: 'MBridge',
                from: _this5.getInviewId(),
                to: keep.id
              }, _this5.options.retry).then(function () {//
              }).catch(function (e) {// console.log(e)
              });
            }

            resolve();
          });
        }).catch(function (e) {
          console.log('%s Error when sending the sample to %s', _this5.PEER, oldest); // try with another peers or skip

          resolve();
        });
      }).then(function () {
        _this5.emit('end-shuffle');

        return Promise.resolve();
      }).catch(function (e) {
        _this5.emit('end-shuffle');

        return Promise.reject(e);
      });
    }
  }, {
    key: "_onExchange",
    value: function _onExchange(id, message) {
      var _this6 = this;

      // the receiving node Q replies by sending back a random subset of at most l of its neighbors,
      //  and updates its own cache to accommodate all received entries.
      //  It does not increase, though, any entry’s age until its own turn comes to initiate a shuffle.
      var saveSample = message.sample.slice(0);
      var saveOriginator = String(message.from);

      var sample = this._getSample(this.options.maxPeers);

      debug('[%s] Answer to a an exchange demande with %s with a sample of size: %f', this.PEER, saveOriginator, sample.length); // now reply

      message.type = 'MExchangeBack';
      message.sample = sample;
      message.from = this.getInviewId();
      this.send(id, message, this.options.retry); // 6. Discard entries pointing at P and entries already contained in P’s
      // cache.

      var tokeep = saveSample.filter(function (samp) {
        if (_this6._partialView.has(samp.id)) {
          return false;
        } else {
          return true;
        }
      }); // 7. Update P’s cache to include all remaining entries, by firstly using empty
      // cache slots (if any), and secondly replacing entries among the ones sent to Q.

      for (var i = 0; i < tokeep.length; i++) {
        var keep = tokeep[i];

        if (this._partialView.size >= this.options.maxPeers) {
          // replacement of links into our pv...
          var rn = Math.floor(Math.random() * sample.length);
          var idrn = sample[rn].id;
          sample.splice(rn, 1);
          debug('[%s] replacing entry %s by %s', this.PEER, idrn, keep.id);
          this.disconnect(idrn);

          this._partialView.removeAll(idrn);
        }

        this.send(id, {
          type: 'MBridge',
          from: this.getInviewId(),
          to: keep.id
        }, this.options.retry).then(function () {//
        }).catch(function (e) {// console.log(e)
        });
      }
    }
  }, {
    key: "_getSample",
    value: function _getSample(size) {
      var sample = []; // #1 create a flatten version of the partial view

      var flatten = [];

      this._partialView.forEach(function (ages, neighbor) {
        flatten.push({
          id: neighbor,
          age: ages[0]
        });
      }); // #2 process the size of the sample, at maximum maxPeers


      var sampleSize = Math.min(flatten.length, size); // #3 add neighbors to the sample chosen at random

      while (sample.length < sampleSize) {
        var rn = Math.floor(Math.random() * flatten.length);
        sample.push(flatten[rn]);
        flatten.splice(rn, 1);
      }

      ;
      return sample;
    }
    /**
     * Get k neighbors from the partial view. If k is not reached, it tries to
     * fill the gap with neighbors from the inview.  It is worth noting that
     * each peer controls its outview but not its inview. The more the neigbhors
     * from the outview the better.
     * @param {number} k The number of neighbors requested. If k is not defined,
     * it returns every known identifiers of the partial view.
     * @return {string[]} Array of identifiers.
     */

  }, {
    key: "getPeers",
    value: function getPeers(k) {
      var peers = [];

      if (typeof k === 'undefined') {
        // #1 get all the partial view
        this._partialView.forEach(function (occ, peerId) {
          peers.push(peerId);
        });
      } else {
        // #2 get random identifier from outview
        var out = [];

        this._partialView.forEach(function (ages, peerId) {
          return out.push(peerId);
        });

        while (peers.length < k && out.length > 0) {
          var rn = Math.floor(Math.random() * out.length);
          peers.push(out[rn]);
          out.splice(rn, 1);
        }

        ; // #3 get random identifier from the inview to fill k-entries

        var inView = [];
        this.i.forEach(function (occ, peerId) {
          return inView.push(peerId);
        });

        while (peers.length < k && inView.length > 0) {
          var _rn = Math.floor(Math.random() * inView.length);

          peers.push(inView[_rn]);
          inView.splice(_rn, 1);
        }

        ;
      }

      ; // debug('[%s] %s provides %s peers', this.PID, this.PEER, peers.length)

      return peers;
    }
  }, {
    key: "_onBridge",
    value: function _onBridge(from, to) {
      // debug('[%s] Bridge bewteen (%s,%s)', this.PEER, from, to)
      if (from !== to) this.connect(from, to);
    }
    /**
     * @private A connection failed to establish properly, systematically
     * duplicates an element of the partial view.
     * @param {string|null} peerId The identifier of the peer we failed to
     * establish a connection with. Null if it was yet to be known.
     */

  }, {
    key: "_onArcDown",
    value: function _onArcDown(peerId) {
      debug('[%s] ONARCDOWN ==> %s =X> %s', this.PID, this.PEER, peerId || 'unknown');
    }
  }, {
    key: "partialView",
    get: function get() {
      return this._partialView;
    }
  }]);

  return Cyclon;
}(N2N);